/** The sizes the viewer toolbar steps through, smallest to largest. */
export const ADD_ON_FONT_SCALES = [0.85, 1, 1.15, 1.3, 1.5] as const;

function nearestIndex(scale: number): number {
    let closest = 0;
    let smallestDiff = Infinity;
    ADD_ON_FONT_SCALES.forEach((step, index) => {
        const diff = Math.abs(step - scale);
        if (diff < smallestDiff) {
            smallestDiff = diff;
            closest = index;
        }
    });
    return closest;
}

/**
 * The listed step closest to `scale`. Catches a value outside the list
 * (state from an older build, a stored value a step size no longer
 * offers) before it is stored, so every reader downstream — this module
 * included — only ever sees a listed size.
 */
export function nearestScale(scale: number): number {
    return ADD_ON_FONT_SCALES[nearestIndex(scale)];
}

/**
 * The step next to `current` in `direction`, or `current` itself past
 * either end. `current` is assumed to already be a listed step, which is
 * what storing it through `nearestScale` guarantees.
 */
export function nextScale(current: number, direction: 1 | -1): number {
    const index = ADD_ON_FONT_SCALES.indexOf(current as (typeof ADD_ON_FONT_SCALES)[number]);
    const clamped = Math.min(Math.max(index + direction, 0), ADD_ON_FONT_SCALES.length - 1);
    return ADD_ON_FONT_SCALES[clamped];
}
